<div class="wpee-online-members-inner wpee-block" *ngIf="onlineMember.length > 0">
    <div class="wpee-block-header">
        <h4 class="wpee-block-title">Online Members</h4>
    </div>
    <div class="wpee-online-members-inner wpee-block-content ">
        <ul class="online-members-section">
            <li *ngFor="let online of onlineMember">
                <a (click)="view_member(online.username)">
                    <img [src]="online.thumbnail_image_url">
                </a>
            </li>
        </ul>
    </div>
</div>